import ApiClient from 'api-client/ApiClient'
import store from 'app/store'
import ActionsSet from 'core/actions/ActionsSet'
import CreateAction from 'core/actions/CreateAction'
import DeleteAction from 'core/actions/DeleteAction'
import ListAction from 'core/actions/ListAction'
import { cacheActions } from 'core/caching/cacheReducers'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import { getCurrentUser } from 'openstack/helpers'

const { dispatch } = store
const { nova } = ApiClient.getInstance()

export const sshKeyActions = ActionsSet.make<DataKeys.SshKeys>({
  uniqueIdentifier: 'name',
  entityName: entityNamesByKey.SshKeys,
  cacheKey: DataKeys.SshKeys,
})

export const listSshKeys = sshKeyActions.add(
  new ListAction<DataKeys.SshKeys>(async () => {
    const keypairs = await nova.getSshKeys()
    return keypairs.map((keypair) => keypair.keypair)
  }),
)

export const createSshKey = sshKeyActions.add(
  new CreateAction<DataKeys.SshKeys, { body }>(async ({ body }) => {
    const created = await nova.createSshKey(body)
    const currentUser = getCurrentUser()
    if (!body?.keypair?.user_id || currentUser.id === body?.keypair?.user_id) {
      const keyName = created.name
      const newSshKey = await nova.getSshKey(keyName)
      return newSshKey
    } else {
      return null
    }
  }),
)

export const deleteSshKey = sshKeyActions.add(
  new DeleteAction<DataKeys.SshKeys, { name: string }>(async ({ name }) => {
    await nova.deleteSshKey(name)
  }),
)

export const getSshKeysForUser = async ({ userId }) => {
  const keypairs = await nova.getSshKeysForUser({ userId })
  return keypairs.map((keypair) => keypair.keypair)
}

export const createSshKeyForUser = async ({ body }) => {
  return nova.createSshKeyForUser({ body })
}

export const deleteSshKeyForUser = async ({ name, userId }) => {
  return nova.deleteSshKeyForUser({ name, userId })
}
